export default __webpack_public_path__ + "static/media/photo_left_4.5362f89b.png";